<template>
  <div class="recommendOne">
    <div class="recommendOne-left">
      <recommend-title :titleObj="titleObj"></recommend-title>
      <div class="list-panel">
        <ul>
          <li v-for="(item,index) in list" :key="index">
            <div class="li-panel">
              <list-panel :obj="item" :star="true"></list-panel>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="recommendOne-right">
      <recommend-title :titleObj="titleObj1"></recommend-title>
      <recommend-list :recommendList="recommendList"></recommend-list>
    </div>
  </div>
</template>
<script>
import RecommendTitle from './recommendTitle'
import ListPanel from './listPanel'
import RecommendList from './recommendList'
export default {
  name: '',
  components: {
    'recommend-title': RecommendTitle,
    'list-panel': ListPanel,
    'recommend-list': RecommendList
  },
  data () {
    return {
      titleObj: {
        color: 'red',
        text: '重磅推荐',
        link: '/home/specialoffer/zbrecommend'
      },
      titleObj1: {
        color: '#7E7B87',
        text: '畅销榜',
        link: 'Ranking',
        type: '1'
      },
      list: [
      //   {
      //   imgUrl: require('@/assets/images/2.png'),
      //   name: 'w我们从此是路人',
      //   author: '老王',
      //   oldMoney: '100.00',
      //   nowMoney: '50.22',
      //   score: 5
      // }
      ],
      recommendList: []
    }
  },
  methods: {
    getRanking () { // 获取排行榜数据
      const par = `?type=1&start=0&num=5&period=year`
      this.$get(this.$allUrl.getRanking + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          list.forEach(e => {
            this.recommendList.push({
              id: e.bookId,
              imgUrl: require('@/assets/images/2.png'),
              name: e.bookName,
              author: e.bookAuthors
            })
          })
        }
      })
    },
    getBlockbuster () { // 获取最新特价数据
      const par = `?start=0&num=5`
      this.$get(this.$allUrl.getBlockbuster + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            this.list.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              author: e.bookAuthors,
              oldMoney: e.paperPrice,
              nowMoney: e.promotionPrice,
              bookPrice: e.emark === 0 ? '' : e.bookPrice,
              score: 0,
              paperPromotionPrice: e.paperPromotionPrice
            })
          })
        }
      })
    }
  },
  mounted () {
    this.getRanking()
    this.getBlockbuster()
  }
}
</script>
<style lang="less" scoped>
  .recommendOne{
    margin-top: 30px;
    display: flex;
    .recommendOne-left{
      flex: 1;
      padding: 0 10px 0 10px;
      .list-panel{
        ul{
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          flex-wrap: wrap;
          li{
            min-width: 20%;
            max-width: 20%;
            .li-panel{
              padding: 10px 10px 10px 0;
              height: 100%;
            }
          }
        }
      }
    }
    .recommendOne-right{
      width: 250px;
      background-color: #F7F7F7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/recommendOne.vue


// WEBPACK FOOTER //
// src/components/Home/recommendOne.vue